import { useEffect, useRef, useState } from 'react';

export default function DriverLanguageDropdown({
  options,
  value,
  onChange,
  ariaLabel = 'Language',
  testId = 'driver-language-dropdown',
  className = '',
  showCaption = false,
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selectedOption = options.find((option) => option.code === value) || options[0];

  useEffect(() => {
    if (!open) return undefined;

    const closeOnOutside = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('pointerdown', closeOnOutside);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOnOutside);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);

  const choose = (option) => {
    onChange(option.code);
    setOpen(false);
  };

  return (
    <div
      ref={rootRef}
      className={`driver-language-dropdown ${open ? 'is-open' : ''} ${className}`.trim()}
      data-testid={testId}
    >
      <button
        type="button"
        className="driver-language-dropdown-trigger"
        aria-label={ariaLabel}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <span className="driver-language-dropdown-current">
          <strong>{selectedOption.label}</strong>
          {showCaption && selectedOption.caption && <small>{selectedOption.caption}</small>}
        </span>
        <span className="driver-language-dropdown-caret" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="m6 9 6 6 6-6" />
          </svg>
        </span>
      </button>

      {open && (
        <div className="driver-language-dropdown-menu" role="listbox" aria-label={ariaLabel}>
          {options.map((option) => {
            const selected = option.code === value;
            return (
              <button
                key={option.code}
                type="button"
                className={`driver-language-dropdown-option ${selected ? 'is-selected' : ''}`}
                role="option"
                aria-selected={selected}
                onClick={() => choose(option)}
                data-testid={`${testId}-${option.code}`}
              >
                <span className="driver-language-dropdown-dot" aria-hidden="true" />
                <span>
                  <strong>{option.label}</strong>
                  {showCaption && option.caption && <small>{option.caption}</small>}
                </span>
                {selected && <em aria-hidden="true">✓</em>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
